import {DoppePageViewerPart} from "../../components/doppe-page-viewer-part/doppe-page-viewer-part";
import {Values} from "@wix/devzai-utils-common";

export const DoppePageViewerPreventedOperation = {
    ContactFormSubmission: 'ContactFormSubmission',
    DownloadFile: 'DownloadFile',
} as const;

export type DoppePageViewerPreventedOperation = Values<typeof DoppePageViewerPreventedOperation>;

export interface BymoPagePreviewHostServiceApi {
    emit<EVENT extends keyof BymoPagePreviewHostServiceApi.Events> (
        previewServiceWindow: Window,
        eventName: EVENT,
        params: BymoPagePreviewHostServiceApi.Events[EVENT]
    ) : void;
}

export interface IBymoPagePreviewHostServiceApiClient {
    emitBymoPagePreviewEvent<EVENT extends keyof BymoPagePreviewHostServiceApi.Events> (
        eventName: EVENT,
        params: BymoPagePreviewHostServiceApi.Events[EVENT]
    ) : void;
}


export namespace BymoPagePreviewHostServiceApi {

    export interface Events {
        previewServiceReady: {};
        beforeUnload: {};
        eventLinkNavigationPrevented: {
            url: string;
            viewerPart?: DoppePageViewerPart;
        };
        eventAutoSkipPrevented: {};
        eventSkipPrevented: {};

        eventActionPrevented: {
            preventedOperation?: DoppePageViewerPreventedOperation;
        };
    }

}